<div class="actionheader">

  <!-- Un bouton natif DÉSACTIVÉ n'émet aucun événement souris : l'infobulle qui dit POURQUOI
  l'enregistrement est fermé doit donc vivre sur ce conteneur, jamais sur le bouton. -->
  <span class="save-wrap" [matTooltip]="saveTooltip" [matTooltipDisabled]="!saveTooltip">
    <button id="savebutton" [disabled]="!canSave" aria-label="Enregistrer" color="primary" style="margin:8px;" type="button"
      class=" custom-filled-button success" (click)="onSubmit($event)" [attr.form]=form>

      <mat-icon>save</mat-icon>
      &nbsp;Enregistrer
    </button>
  </span>

  <!--
  <button  type="button" class="custom-filled-button success" >
    <mat-icon class="" fontSet="material-symbols-outlined">graph_2</mat-icon>
    success
  </button>

  <button  type="button" class="custom-filled-button " >Primary</button>
  <button  type="button" class="custom-filled-button secondary" >Secondary</button>
  <button  type="button" class="custom-filled-button neutral" >neutral</button>
  <button  type="button" class="custom-filled-button neutral-variant" >neutral-variant</button>
  <button  type="button" class="custom-filled-button warning" >warning</button>
  <button  type="button" class="custom-filled-button info" >Info</button>
  <button  type="button" class="custom-filled-button error" >error</button>

  -->

  <!-- [ngClass]="{'btn-success pending' :  (actionBarState$ | async )!.saveStatus && (actionBarState$ | async )!.hasChange   }" -->
  <!-- {{(saveStatusButtonSubject$ | async).saveStatus }}  -->
  <!-- <button *ngIf="hassave" id="submitButton" mat-icon-button matTooltip="Enregistrer" color="primary" aria-label="Enregister" type="button" (click)="onSubmit($event)" [attr.form]=form>
  <mat-icon>save</mat-icon>
</button> -->
@if (hasback) {
  <button mat-icon-button matTooltip="Annuler" color="primary" aria-label="Cancel" (click)="onCancel()"
    type="button">
    <mat-icon>undo</mat-icon>
  </button>
}
<span class="spacer"></span>
<ng-content></ng-content>
</div>

<!-- [disabled] = "!( (actionBarState$ | async )!.saveStatus && (actionBarState$ | async )!.hasChange)" -->